import { getPropClassesFromInstance } from 'lib/getPropClasses';
import cx from 'classnames';
import pickGlobalElementProps from 'utils/pickInputElementProps';
import * as React from 'react';

import './styles/Badge.scss';

/**
 * ## Displays a numeric or text value within a colored container.
 * ### Typically placed in proximity of an icon or line of text in order to indicate new activity on a particular object, like a class or person.
 *
 * ```example
 * <div>
 *   <Badge text={5} />
 *   <Badge
 *     color="apple"
 *     text={0}
 *     shape="square"
 *   />
 *   <Badge
 *     color="mascot"
 *     text={1}
 *     size="large"
 *   />
 * </div>
 * ```
 *
 *
 * # TODO
 * * Consider removing options given limted usage, clean up and clarify remaining props
 */

type BadgeColor = 'apple' | 'mascot' | 'percussion' | 'pennant' | 'whiteout' | 'plum' | 'atlas';
type BadgeShape = 'circle' | 'square';
type BadgeSize = 'large' | 'medium';

export type Props = {
  color: BadgeColor;
  text: number | string | React.ReactElement;
  shape: BadgeShape;
  size: BadgeSize;
  className?: string;
};

type DefaultProps = {
  color: BadgeColor;
  shape: BadgeShape;
  size: BadgeSize;
};

class Badge extends React.Component<Props> {
  static propClasses = {
    color: {
      apple: 'Badge--apple',
      mascot: 'Badge--mascot',
      percussion: 'Badge--percussion',
      pennant: 'Badge--pennant',
      plum: 'Badge--plum',
      whiteout: 'Badge--whiteout',
      atlas: 'Badge--atlas',
    },
    shape: {
      circle: 'Badge--circle',
      square: 'Badge--square',
    },
    size: {
      medium: 'Badge--medium',
      xsmall: 'Badge--xsmall',
    },
  };

  static defaultProps: DefaultProps = {
    color: 'pennant',
    shape: 'circle',
    size: 'large',
  };

  render() {
    const { className, text, ...others } = this.props;
    const divProps = pickGlobalElementProps(others);

    return (
      <div {...divProps} className={cx('Badge', getPropClassesFromInstance(this), className)}>
        {text}
      </div>
    );
  }
}

export default Badge;
